import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryInvoiceChargeUnit(requestBody) {
  return request({
    url: URL.act.invoiceChargeUnit.queryUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveInvoiceChargeUnit(requestBody) {
  return request({
    url: URL.act.invoiceChargeUnit.saveUrl,
    method: 'post',
    data: requestBody
  })
}

export function deleteInvoiceChargeUnit(requestBody) {
  return request({
    url: URL.act.invoiceChargeUnit.deleteUrl,
    method: 'post',
    data: requestBody
  })
}
